import {
  APP_STATUS_TABLE_PREVIEW_LENGTH,
  truncateAppStatusText,
} from '@src/main/modules/app_status/ui/utils/appStatusIncidents.utils';
import { FC } from 'react';
import styles from './AppStatusIncidents.module.scss';

type AppStatusTextPreviewProps = {
  value: string;
};

const AppStatusTextPreview: FC<AppStatusTextPreviewProps> = ({ value }) => {
  const isTruncated = value.length > APP_STATUS_TABLE_PREVIEW_LENGTH;

  return (
    <span
      className={styles['truncated-text']}
      data-pr-tooltip={isTruncated ? value : undefined}
      aria-label={value}
    >
      {truncateAppStatusText(value)}
    </span>
  );
};

export default AppStatusTextPreview;
